import React from 'react';
import {Text, ThemeConsumer} from 'react-native-elements';
import {__} from '@ampeco/i18n';
import {formatDualCurrencyPrice} from '@ampeco/currency';
import WarningNotice from './WarningNotice';
import {Session} from '@ampeco/charge-models';
import {Observer} from 'mobx-react';
import {ImageStyle} from "react-native";

export default (props: {session: Session, onPress?: () => void, inverse?: boolean, onMap?: boolean, iconStyle?: ImageStyle}) => {

    return <ThemeConsumer>{({theme}) => {
        const bold = {...theme.Notice.boldTextStyle, ...(props.onMap ? theme.Notice.mapTextStyle : theme.Notice.textStyle)};

        return <WarningNotice
            onPress={props.onPress}
            onMap={props.onMap}
            iconStyle={props.iconStyle}
        >
            <Text style={bold}>{__('notice.unpaid-session')}</Text>
            <Observer>{() => {
                return <Text style={props.onMap ? theme.Notice.mapTextStyle : theme.Notice.textStyle}>
                    {__('notice.unpaid-session-details').replace('{amount}', formatDualCurrencyPrice({
                        amount: props.session.amountDue,
                        currencyId: props.session.currencyId,
                        operatorCountry: props.session.operatorCountry,
                    }))}
                </Text>;
            }}</Observer>
        </WarningNotice>;
    }}</ThemeConsumer>;
};
